import $ from 'jquery';

$(function() {

    //console.log('product-prices.js');

    // Temporarily disabled to allow page load optimisation

    //initProductIndexPriceLookup();

    initProductIndexPagePrices();
    initProductIndexOrderItem();
    initModifyQuantityButtons();

    initFavouritesHideImages();
    initCampaignHideImages();

    initRemoveFavourite();

});


function initProductIndexPagePrices() {

    // This uses stored data from the PriceList Interface to get product list prices
    //console.log('initProductIndexPagePrices');

    let accountCode = $('#account-code').val();
    if (!accountCode) { return; }

    //let $productControls = $('.product-controls.product-tile');
    let $productControls = $('.product-tile-view-price')
    let productControlsLength = $productControls.length;

    let productCodes = [];

    $productControls.each(function(index, item) {
        productCodes.push($(this).attr('data-product-code'));
    });

    //console.log(productCodes);

    let data = {
        account_code: accountCode,
        product_codes: productCodes
    };

    //console.log(data);

    //getListPrices(data);

    // Get all availability in one go
    getListAvailability(data);

    // Or do it one by one
    // productCodes.forEach(function(productCode) {
    //
    //     let availabilityData = {
    //         account_code: accountCode,
    //         product_codes: productCode
    //     }
    //
    //     console.log(availabilityData);
    //
    //     getProductAvailability(availabilityData);
    //
    // });

}



function getListAvailability(data) {

    axios.post('/product/get-list-availability', data).then(function (response) {

        //console.log(response);

        if (!response.data) {

            // Something went wrong - badly formatted result
            console.log('The server returned badly formed data');
            console.log(response);

        } else if (!response.data.product_availability) {

            // The server returned an error of some sort
            console.log('The server returned an error of some sort');
            console.log(response);

        } else {

            // Let's assume for the moment we have well-formed data ...
            let productAvailability = response.data.product_availability;

            Object.keys(productAvailability).forEach(function(productCode) {

                let stockLevel = productAvailability[productCode];
                let $priceBlock = $('.product-tile-view-price[data-product-code=' + productCode + ']').first();

                // Check if we have any in stock
                if (stockLevel === null) {
                    // Allow the user to view but nothing else
                    $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'none');
                    $priceBlock.find('a').html('View');
                    $priceBlock.removeClass('hidden');
                } else {
                    stockLevel = parseInt(stockLevel);
                    if (stockLevel === 0) {
                        // Set the out of stock flag
                        $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'block');
                        $priceBlock.find('a').html('View');
                        $priceBlock.removeClass('hidden');
                    } else {
                        // Show the order panel
                        $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'none');
                        $priceBlock.find('a').html('View price &amp; buy');
                        $priceBlock.removeClass('hidden');
                    }
                }

            });

        }

    })["catch"](function (error) {
        console.log(error);
    });

}


function getListPrices(data) {

    axios.post('/product/get-list-prices', data).then(function (response) {

        //console.log(response);

        if (!response.data) {

            // Something went wrong - badly formatted result
            console.log('The server returned badly formed data');
            console.log(response);

        } else if (!response.data.product_prices) {

            // The server returned an error of some sort
            console.log('The server returned an error of some sort');
            console.log(response);

        } else {

            // Let's assume for the moment we have well-formed data ...
            //console.log('The server returned well-formed data');
            //console.log($priceBlock);

            let productPrices = response.data.product_prices;

            //console.log(productPrices);
            //console.log(Object.keys(productPrices));

            Object.keys(productPrices).forEach(function(productCode) {
                //console.log(productCode);
                //console.log(productPrices[productCode]);

                let listPrice = parseFloat(productPrices[productCode]);

                let $priceBlock = $('.product-controls.product-tile[data-product-code=' + productCode + ']').first();
                $priceBlock.find('.currentpricevalue').text('£' + listPrice.toFixed(2));
                $priceBlock.find('.order-button').closest('.ajax-order-form').attr('data-price', listPrice.toFixed(2));
                $priceBlock.removeClass('hide');

            });

        }

    })["catch"](function (error) {
        console.log(error);
    });

}


function initProductIndexPriceLookup() {

    let accountCode = $('#account-code').val();

    if (!accountCode) { return; }

    //console.log('initProductIndexPriceLookup');
    //const start = Date.now();

    let $productControls = $('.product-controls');
    let productControlsLength = $productControls.length;

    // Go through each product on the page and update the customer specific prices
    $productControls.each(function(index, item) {

        let $priceBlock = $(this);

        let productCode = $priceBlock.attr('data-product-code');

        let data = {
            product_code: productCode
        };

        //console.log(data);

        let targetUrl = '/product/get-customer-price';

        axios.post(targetUrl, data).then(function (response) {

            //console.log(response);

            //if (index === (productControlsLength - 1)) {
            //let duration = Date.now() - start;
            //console.log('initProductIndexPriceLookup: ' + duration + 'ms');
            //console.log(response);
            //}

            if (!response.data) {

                // Something went wrong - badly formatted result
                console.log('The server returned badly formed data');
                console.log(response);

            } else if (!response.data.product_code) {

                // The server returned an error of some sort
                console.log('The server returned an error of some sort');
                console.log(response);

            } else {
                // Let's assume for the moment we have well-formed data ...
                //console.log('The server returned well-formed data');
                //console.log($priceBlock);

                let price = parseFloat(response.data.price);
                let retailPrice = parseFloat(response.data.retail_price);
                let listPrice = parseFloat(response.data.list_price);

                // Set the price if it is set
                if (price != 0) {
                    // Check if this is a last chance page ...
                    if ($priceBlock.find('.oldpricevalue').length) {
                        if (price < retailPrice) {
                            $priceBlock.find('.currentpricevalue').text('£' + price.toFixed(2));
                        } else {
                            $priceBlock.find('.currentpricevalue').text('£' + retailPrice.toFixed(2));
                        }
                        $priceBlock.find('.oldpricevalue').text('£' + listPrice.toFixed(2));
                    } else {
                        // Commented out as the whole list price thing is apparently a bit controversial ...
                        //if (listPrice > price) {
                        //    $priceBlock.find('.listpricevalue').text('List £' + listPrice.toFixed(2));
                        //}
                        $priceBlock.find('.currentpricevalue').text('£' + price.toFixed(2));
                    }
                    $priceBlock.removeClass('hide');
                }

                // Check if we have any in stock
                if (!response.data.in_stock) {
                    // Set the out of stock flag
                    $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'block');
                } else {
                    // Show the order panel
                    $priceBlock.find('.order-button').closest('.ajax-order-form').attr('data-price', price.toFixed(2));
                    $priceBlock.find('.product-add-to-cart').removeClass('hide');
                }

            }

        })["catch"](function (error) {
            console.log(error);
        });

    });

}


function initProductIndexOrderItem() {

    //console.log('initProductIndexOrderItem');

    $('.ajax-order-form .order-button').unbind('click');
    $('.ajax-order-form .order-button').on('click', function(event) {

        event.preventDefault();

        console.log('order-button:click');

        let button = $(this);
        let quantity = button.closest('.ajax-order-form').find('input.order-quantity').val();
        let productVariantId = button.closest('.product-controls').attr('data-product-variant-id');
        let productId = button.closest('.product-controls').attr('data-product-id');
        let productCode = button.closest('.product-controls').attr('data-product-code');
        let basketItemId = button.closest('.product-controls').attr('data-basket-item-id');
        let price = button.closest('.ajax-order-form').attr('data-price');

        button.html('Adding <i class="fas fa-circle-notch fa-spin">');

        if (!basketItemId) {

            let data = {
                productVariantId: productVariantId,
                productId: productId,
                productCode: productCode,
                basketItemId: basketItemId,
                itemQuantity: quantity,
                itemPrice: price,
                incGA4: true
            };
            let targetUrl = '/manager/ecommerce/basket/add-item?' + Date.now();
            axios.post(targetUrl, data).then(function (response) {

                console.log(response);

                if (!response.data) {
                    // Something went wrong - badly formatted result
                    //console.log('The server returned badly formed data');
                    //console.log(response);
                } else {

                    if (response.data.result === 'error') {

                        showBasketError();
                        button.html('Order');

                    } else {

                        let basketDetails = response.data.basketDetails;

                        // Update the basket total
                        $('#basket-count').text(basketDetails.basket_item_count);
                        $('#current_basket_count').removeClass('hide');

                        showBasketUpdated();

                        // Update the mini basket, if present
                        updateMiniBasket(basketDetails);
                        // Update the full basket if present
                        customUpdateBasket(basketDetails);

                        let newBasketItemId = '';
                        let newQuantity = 1;
                        for (let item of basketDetails.items) {
                            if (item['product_code'] == productCode) {
                                newBasketItemId = item['item_id'];
                                newQuantity = item['quantity'];
                                break;
                            }
                        }
                        button.closest('.ajax-order-form').attr('data-basket-item-id', newBasketItemId);
                        button.closest('.ajax-order-form').find('input.order-quantity').val(newQuantity);
                        button.html('Update');

                        if (response.data.ga4 && (response.data.ga4 != '')) {
                            // Clear the dataLayer ecommerce object
                            dataLayer.push({ecommerce: null});
                            // Add the new ga4 data
                            dataLayer.push(response.data.ga4);
                        }

                    }

                }

            })["catch"](function (error) {
                console.log(error);
            });

        } else {

            let data = {
                productVariantId: productVariantId,
                productId: productId,
                productCode: productCode,
                basketItemId: basketItemId,
                quantity: quantity,
                itemPrice: price,
                incGA4: true
            };
            let targetUrl = '/manager/ecommerce/basket/update-item?' + Date.now();
            axios.post(targetUrl, data).then(function (response) {

                console.log(response);

                if (!response.data) {
                    // Something went wrong - badly formatted result
                    //console.log('The server returned badly formed data');
                    //console.log(response);
                } else {

                    if (response.data.result === 'error') {

                        showBasketError();

                    } else {

                        let basketDetails = response.data.basketDetails;

                        // Update the basket total
                        $('#basket-count').text(basketDetails.basket_item_count);
                        $('#current_basket_count').removeClass('hide');

                        showBasketUpdated();

                        // Update the mini basket, if present
                        updateMiniBasket(basketDetails);
                        // Update the full basket if present
                        customUpdateBasket(basketDetails);

                        let newBasketItemId = '';
                        let newQuantity = 1;
                        for (let item of basketDetails.items) {
                            if (item['product_code'] == productCode) {
                                newBasketItemId = item['item_id'];
                                newQuantity = item['quantity'];
                                break;
                            }
                        }
                        button.closest('.ajax-order-form').attr('data-basket-item-id', newBasketItemId);
                        button.closest('.ajax-order-form').find('input.order-quantity').val(newQuantity);
                        button.html('Update');

                        if (response.data.ga4 && (response.data.ga4 != '')) {
                            // Clear the dataLayer ecommerce object
                            dataLayer.push({ecommerce: null});
                            // Add the new ga4 data
                            dataLayer.push(response.data.ga4);
                        }

                    }

                }

            })["catch"](function (error) {
                console.log(error);
            });

        }



    });

}

function showBasketUpdated() {

    let alert = '<div id="basketUpdated" style="display:none;"><div><p>Added to basket</p></div><div>You have just added that item to your basket<br /> <a href="/account/basket">View your basket</a></div></div>';

    $('#main').append(alert);
    $('#basketUpdated').fadeIn(300);

    setTimeout(function() {
        $('#basketUpdated').fadeOut(300, function() { $(this).remove(); });
    }, 3000);

}

function showBasketError() {

    let alert = '<div id="basketUpdated" style="display:none;"><div><p>Could not add to basket</p></div><div>Sorry, there was an error and your basket was not updated</div></div>';

    $('#main').append(alert);
    $('#basketUpdated').fadeIn(300);

    setTimeout(function() {
        $('#basketUpdated').fadeOut(300, function() { $(this).remove(); });
    }, 3000);

}


function updateMiniBasket(basketDetails) {

    // Check if the mini basket is present
    if (!$('.tbl-basketmini').length) {
        return;
    }

    let currencySymbol = basketDetails.currency_symbol;
    let $miniBasket = $('<table cellPadding="0" cellSpacing="0" class="tbl-basketmini"><tbody></tbody></table>');

    basketDetails.items.forEach((item) => {
        $miniBasket.find('tbody').append($([
            '<tr>',
            '<td><span>' + item.quantity + ' x ' + item.title + '</span><br>' + item.size + ' ' + item.abv + '</td>',
            '<td>' + currencySymbol + item.item_gross + '</td>',
            '<tr>'
        ].join('')));
    });

    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Subtotal:</td><td class="basketminittl">' + currencySymbol + basketDetails.item_total + '</td></tr>'));
    if (basketDetails.shipping_net) {
        $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Shipping:</td><td class="basketminittl">' + currencySymbol + basketDetails.shipping_net + '</td></tr>'));
    }
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">VAT:</td><td class="basketminittl">' + currencySymbol + basketDetails.tax + '</td></tr>'));
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Gross Total:</td><td class="basketminittl">' + currencySymbol + basketDetails.gross_total + '</td></tr>'));

    $('.tbl-basketmini').replaceWith($miniBasket);

    if (basketDetails.items.length) {
        $('.btn-continue').removeClass('hide');
    } else {
        $('.btn-continue').addClass('hide');
    }

}


window.customUpdateBasket = function (basketDetails) {

    // Add handling of minimum order level warning message ...
    let messages = [];

    // Stock level error message
    if (basketDetails.has_out_of_stock_items || basketDetails.has_insufficient_stock_items) {
        messages.push({
            type: 'error',
            message: 'WARNING: You cannot continue your order - there is not enough stock available for the order lines indicated below. Please amend the quantity or delete the order line(s) to continue.'
        });
    }

    // Minimum order warning
    if (basketDetails.minimum_order_num > basketDetails.item_total_num) {
        messages.push({
            type: 'warning',
            message: 'Your basket item total is currently below your minimum order level. ' +
                     'Add £' + (basketDetails.minimum_order_num - basketDetails.item_total_num).toFixed(2) + ' to avoid shipping charges.'
        });
    }

    // Clear existing flash messages
    $('.flash-message').remove();

    if (messages.length) {
        let messageHtml = '';
        messages.forEach(function(message) {
            messageHtml += '<div class="flash-message ' + message.type + '">' + message.message + '</div>'
        });
        $(messageHtml).insertBefore('div.basket');
    }

    // Show / hide the Checkout button
    if ((basketDetails.has_insufficient_stock_items) || (basketDetails.has_out_of_stock_items)) {
        $('form.custom-order-details button.primary').addClass('hidden');
        $('form.custom-order-details div.custom-order-details-wrapper').addClass('hidden');
    } else {
        $('form.custom-order-details button.primary').removeClass('hidden');
        $('form.custom-order-details div.custom-order-details-wrapper').removeClass('hidden');
    }

    // Check if the basket is present
    if (!$('.tblbasket').length) {
        return;
    }

    // Get basket html
    let targetUrl = '/basket/get-updated';
    let amend = $('.basketheaderl').length;
    axios.post(targetUrl, { amend: amend }).then(function (response) {
        //console.log(response);
        if (!response.data) {
            // Something went wrong - badly formatted result
            console.log('The server returned badly formed data');
            console.log(response);
        } else {
            $('.basket__mobile').replaceWith(response.data.mobile);
            $('.basket__desktop').replaceWith(response.data.desktop);
            $('.basket__totals').replaceWith(response.data.totals);
            // Reinitialise the basket buttons
            initModifyQuantityButtons();
            window.initDeleteBasketItem();
            window.initUpdateBasketItem();
        }
    });

    showBasketChanged();

}


function initModifyQuantityButtons() {

    //console.log('initModifyQuantityButtons');

    $('.modify-quantity').unbind('click');
    $('.modify-quantity').on('click', function() {
        let $container = $(this).parent();
        let $quantity = $container.find('.quantity');
        let val = $quantity.val();

        if ($(this).hasClass('increase')) {
            val++;
        } else if ($(this).hasClass('decrease')) {
            val--;
        }
        if (val < 0) {
            val = 0;
        }

        $quantity.val(val);

        if ($quantity.hasClass('basket-item-quantity')) {
            updateBasketItem($quantity, true);
        }
    });

}


function initFavouritesHideImages() {

    $('#favourites-hide-images').unbind('change');
    $('#favourites-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}


function initRemoveFavourite() {

    $('.remove-favourite').unbind('click');
    $('.remove-favourite').on('click', function() {

        let productVariantId = $(this).attr('data-product-variant-id');

        let url = window.location.pathname;
        let queryParams = new URLSearchParams(window.location.search);
        queryParams.set('remove', productVariantId);
        window.location.href = url + '?' + queryParams.toString();

    });

}


function initCampaignHideImages() {

    $('#campaign-hide-images').unbind('change');
    $('#campaign-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}
